import { Navigate } from "react-router-dom";
import { useAuth, homeForRole } from "@/store/AuthContext";

export const ProtectedRoute = ({ allow, children }) => {
  const { currentUser } = useAuth();

  if (currentUser === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-blue-600" />
      </div>
    );
  }
  if (!currentUser) return <Navigate to="/login" replace />;
  if (currentUser.blocked) return <Navigate to="/assinar" replace />;
  if (allow && !allow.includes(currentUser.role)) return <Navigate to={homeForRole(currentUser.role)} replace />;
  return children;
};
